<template>
  <ContentSection>
    <Container>
      <div class="mx-auto max-w-[49rem]">
        <VideoPlayer
          :video-id="videoId"
          :file="data.file"
          :poster="data.poster"
        />
      </div>
    </Container>
  </ContentSection>
</template>

<script lang="ts" setup>
const props = defineProps<{
  data: {
    youtube_url: string
    file: {
      permalink: string
    }
    poster: {
      permalink: string
    }
  }
}>()

// Extract the video ID from the YouTube URL
const videoId = computed(() => {
  if (!props.data.youtube_url) return undefined

  const videoURL = props.data.youtube_url
  const splited = videoURL.split('v=')

  return splited[1]
})
</script>
